import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"
import { useDevAuth } from "@/hooks/use-dev-auth"

import { fetchFeatureFlags } from "./api"

export function useFetchFeatureFlags() {
  const getContext = useApiContext()
  const { sessionId, userId, orgId, isLoaded, isSignedIn } = useDevAuth()

  return useQuery({
    queryKey: ["feature-flags", sessionId, userId, orgId],
    enabled: isLoaded && isSignedIn,
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")

      const response = await fetchFeatureFlags(context)
      return response.feature_flags
    },
  })
}
